import ValueExpression, {
  TargetValueType,
} from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';
import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';

import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

export default new ValueExpression({
  identifier: 'tourfahrtzeit_anfahrt_avg',
  label: 'Ø Anfahrtszeit',
  valueFormat: '-#.###.##0,0 h',
  valueQuotient: 3600,
  positiveDirection: PositiveDirection.down,
  definition: getDefinitionByName('Anfahrtszeit'),
  targetValueType: TargetValueType.QUOTE,
  decimalPlaces: 2,
});
